import { apiSlice } from './apiSlice';

export interface SlackIntegration {
  id: string;
  team_id: string;
  team_name: string;
  created_at: string;
}

export interface LinkSlackAccountRequest {
  state: string;
  team_name?: string;
}

export const slackApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSlackIntegrations: builder.query<SlackIntegration[], void>({
      query: () => ({
        method: 'GET',
        url: '/slack/integrations',
      }),
      providesTags: ['slack-integrations'],
    }),
    deleteSlackIntegration: builder.mutation<void, string>({
      query: (id) => ({
        method: 'DELETE',
        url: `/slack/integrations/${id}`,
      }),
      invalidatesTags: ['slack-integrations'],
    }),
    linkSlackAccount: builder.mutation<
      { message: string },
      LinkSlackAccountRequest
    >({
      query: (data) => ({
        method: 'POST',
        url: '/slack/auth/callback',
        data,
      }),
    }),
  }),
});

export const {
  useGetSlackIntegrationsQuery,
  useDeleteSlackIntegrationMutation,
  useLinkSlackAccountMutation,
} = slackApiSlice;
